import { render, staticRenderFns } from "./ChannelManagementView.vue?vue&type=template&id=5c846bde&"
import script from "./ChannelManagementView.vue?vue&type=script&lang=js&"
export * from "./ChannelManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports